/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Prop_P1_BoldInputs */

const es_cap_prop_p1_bold = /** @type {(inputs: Cap_Prop_P1_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cuánto vas a cobrar`)
};

const gl_cap_prop_p1_bold = /** @type {(inputs: Cap_Prop_P1_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`canto vas a cobrar`)
};

const en_cap_prop_p1_bold = /** @type {(inputs: Cap_Prop_P1_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`what you will earn`)
};

/**
* | output |
* | --- |
* | "what you will earn" |
*
* @param {Cap_Prop_P1_BoldInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_prop_p1_bold = /** @type {((inputs?: Cap_Prop_P1_BoldInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Prop_P1_BoldInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_prop_p1_bold(inputs)
	if (locale === "en") return en_cap_prop_p1_bold(inputs)
	return es_cap_prop_p1_bold(inputs)
});